module.exports = __webpack_public_path__ + "static/media/ManUtd_gainon_logo.74672fa2.png";